"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4961],{

/***/ 24961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ asset_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/picture-with-link/picture-with-link-component.js
var picture_with_link_component = __webpack_require__(94640);
// EXTERNAL MODULE: ./components/core/video/video-component.js + 1 modules
var video_component = __webpack_require__(3773);
// EXTERNAL MODULE: ./server/services/files-service/files-service.js
var files_service = __webpack_require__(14688);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./client/services/cluster-config-service/cluster-config-service.js
var cluster_config_service = __webpack_require__(79092);
// EXTERNAL MODULE: ./services/community/cloudinary-service.js
var cloudinary_service = __webpack_require__(40927);
;// CONCATENATED MODULE: ./client/services/dynamic-asset-param-service/dynamic-asset-param-service.js

var FALLBACK_IMAGE_FILENAME = "default.png"; // if you don't add this file to your path, you'll have weird "?" image instead in case of missing image
var env = "production";
var getImageUrl = function(folderPath, fileName) {
    var folderPathForEnv = "".concat(folderPath, "/").concat(env);
    var transformation = "".concat(cloudinary_service.FALLBACK_DEFAULT_IMAGE_TRANSFORMATION_PARAM, "_").concat(folderPathForEnv.replace(/\//g, ":"), ":").concat(FALLBACK_IMAGE_FILENAME, ",q_100");
    return "".concat(cloudinary_service.CLOUDINARY_IMAGE_PREFIX, "upload/").concat(transformation, "/").concat(folderPathForEnv, "/").concat(fileName);
};

// EXTERNAL MODULE: ./segments/desktop/core-components/window-mask/window-mask.js + 2 modules
var window_mask = __webpack_require__(26718);
// EXTERNAL MODULE: ./utils/react.js
var utils_react = __webpack_require__(12783);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/asset/asset-component.scss.js

var StyledAssetComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eav27f90"
})("position:relative;border-radius:", function(props) {
    return props.style.borderRadius;
}, ";overflow:hidden;.main-image{width:100%;display:flex;}.main-image.round{border-radius:50%;}img.with-window-mask,.with-window-mask > video{width:100%;border-bottom-left-radius:10px;border-bottom-right-radius:10px;}");

;// CONCATENATED MODULE: ./components/core/asset/asset-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}













var MP4 = "mp4";
var GIF = "gif";
var AssetComponent = function(props) {
    var getAssetsConfig = function() {
        var image = props.image, video = props.video, useDynamicAsset = props.useDynamicAsset, clusterConfig = props.clusterConfig, dynamicAssetParamPath = props.dynamicAssetParamPath, dynamicAssetParam = props.dynamicAssetParam, activePagePath = props.activePagePath;
        if (dynamicAssetParamPath && dynamicAssetParam) {
            return {
                image: _object_spread_props(_object_spread({}, image), {
                    src: getImageUrl(dynamicAssetParamPath, dynamicAssetParam)
                })
            };
        }
        var dynamicAssetConfig = useDynamicAsset && (0,cluster_config_service/* getDynamicAssetConfigForPath */.sP)(clusterConfig, activePagePath);
        if (!dynamicAssetConfig) {
            return {
                image: image,
                video: video
            };
        }
        if ((0,files_service.getFileExtension)(dynamicAssetConfig.src) === MP4) {
            return {
                video: _object_spread_props(_object_spread({}, video), {
                    src: {
                        formats: [
                            dynamicAssetConfig.src
                        ]
                    }
                })
            };
        }
        return {
            image: _object_spread({}, image, dynamicAssetConfig)
        };
    };
    var renderAsset = function() {
        var width = props.width, convertGifToVideo = props.convertGifToVideo, imageClassName = props.imageClassName, assetQuality = props.assetQuality, hideControls = props.hideControls, onStart = props.onStart, onEnded = props.onEnded, onDuration = props.onDuration, hideBlackBars = props.hideBlackBars, onImageLoad = props.onImageLoad;
        var ref = getAssetsConfig(), image = ref.image, video = ref.video;
        if (video === null || video === void 0 ? void 0 : video.src) {
            var formats = video.src.formats;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(video_component/* default */.Z, _object_spread_props(_object_spread({}, video, video.src), {
                formats: formats,
                assetQuality: assetQuality,
                hideControls: hideControls,
                poster: video === null || video === void 0 ? void 0 : video.poster,
                onStart: onStart,
                onEnded: onEnded,
                onDuration: onDuration,
                hideBlackBars: hideBlackBars
            }));
        }
        if (image === null || image === void 0 ? void 0 : image.src) {
            if ((0,files_service.getFileExtension)(image.src) === GIF && convertGifToVideo) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(video_component/* default */.Z, {
                    loop: true,
                    autoPlay: true,
                    formats: [
                        image.src
                    ],
                    assetQuality: assetQuality,
                    ariaLabel: image === null || image === void 0 ? void 0 : image.alt,
                    hideControls: hideControls
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_with_link_component/* default */.Z, _object_spread_props(_object_spread({
                onImageLoad: onImageLoad,
                className: classnames_default()("main-image", imageClassName)
            }, image), {
                specificImageStyle: {
                    width: width
                },
                assetQuality: assetQuality
            }));
        }
        return null;
    };
    var width = props.width, className = props.className, style = props.style, useWindowMask = props.useWindowMask, borderRadius = props.borderRadius;
    var childrenWithWindowMaskClass = function(children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(window_mask/* default */.Z, {
            children: react.Children.map(children, function(child) {
                return /*#__PURE__*/ (0,react.cloneElement)(child, {
                    className: "with-window-mask"
                });
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAssetComponent, {
        className: classnames_default()("asset-inner", className),
        style: _object_spread_props(_object_spread({}, style), {
            width: width,
            borderRadius: borderRadius
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_react/* ConditionalWrapper */.M, {
            condition: useWindowMask,
            wrapper: childrenWithWindowMaskClass,
            children: renderAsset()
        })
    });
};
AssetComponent.defaultProps = {
    convertGifToVideo: false,
    useWindowMask: false
};
/* harmony default export */ var asset_component = ((0,generic_config_context/* withGenericConfig */.P)((0,router.withRouter)(AssetComponent)));


/***/ }),

/***/ 94640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PictureWithLinkComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_core_picture_picture_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82305);
/* harmony import */ var _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65023);






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var PictureWithLinkComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(PictureWithLinkComponent, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(PictureWithLinkComponent);
    function PictureWithLinkComponent() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, PictureWithLinkComponent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(args)));
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "onClick", function(e) {
            var _props = _this.props, href = _props.href, src = _props.src;
            var isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
            BigBrain("track", _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_8__.PICTURE_WITH_LINK_CLICKED, {
                kind: href,
                info1: isKeyboardEvent ? "keyboard" : "mouse",
                info2: src
            });
        });
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(PictureWithLinkComponent, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, href = _this_props.href, target = _this_props.target, otherProps = _object_without_properties(_this_props, [
                    "href",
                    "target"
                ]);
                if (href) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: href,
                        target: target,
                        onClick: this.onClick,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_core_picture_picture_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _object_spread({}, otherProps))
                    });
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_core_picture_picture_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _object_spread({}, otherProps));
            }
        }
    ]);
    return PictureWithLinkComponent;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);

PictureWithLinkComponent.defaultProps = {
    target: "_self"
};


/***/ }),

/***/ 3773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ video_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-player/lib/ReactPlayer.js
var ReactPlayer = __webpack_require__(70390);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/visibility-sensor.js
var visibility_sensor = __webpack_require__(51529);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./services/community/cloudinary-service.js
var cloudinary_service = __webpack_require__(40927);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/video/video-component.scss.js

var StyledVideoComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1gu2uz00"
})("outline:none;&.hide-black-bars{height:32vw;.react-player-video-component video{object-fit:cover;}}");

;// CONCATENATED MODULE: ./components/core/video/video-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var VideoComponent = function(props) {
    var ref = (0,react.useState)(false), isVisible = ref[0], setVisible = ref[1];
    var ref1 = (0,react.useState)(false), hovered = ref1[0], setHovered = ref1[1];
    var ref2 = (0,react.useState)(false), hadFocusWithKeyboardEvent = ref2[0], setHadFocusWithKeyboardEvent = ref2[1];
    /* Video configuration */ var shouldPlayVideo = function() {
        var playWhenVisible = props.playWhenVisible, autoPlay = props.autoPlay, disableAutoplay = props.disableAutoplay, hideControls = props.hideControls;
        if (!hideControls && disableAutoplay) {
            return false;
        }
        if (!playWhenVisible) {
            return autoPlay;
        }
        return isVisible;
    };
    var getUrl = function() {
        var url;
        if (props.singleUrl) {
            url = props.singleUrl;
        } else {
            // Only set urls on init so player is not refreshed on every update
            var formats = props.formats.filter(function(urlFormat) {
                return urlFormat;
            }); // clean undefined
            if (formats.length > 0) {
                if ((0,cloudinary_service.isCloudinaryUrl)(formats[0])) {
                    url = formats[0];
                } else {
                    url = (0,cloudinary_service.generateCloudinaryVideoUrl)(formats[0], {
                        assetQuality: props.assetQuality
                    });
                }
            } else {
                url = [];
            }
        }
        return url;
    };
    var getPoster = function() {
        var poster = props.poster;
        var fixedPosterUrl;
        if (poster) {
            fixedPosterUrl = (0,cloudinary_service.generateCloudinaryImageUrl)(poster);
        } else {
            var formats = props.formats;
            var videoUrl = formats[0];
            if (videoUrl) {
                if ((0,cloudinary_service.isCloudinaryUrl)(videoUrl)) {
                    fixedPosterUrl = (0,cloudinary_service.generateCloudinaryVideoThumbnailFromFullUrl)(videoUrl);
                } else {
                    fixedPosterUrl = (0,cloudinary_service.generateCloudinaryVideoThumbnail)(videoUrl);
                }
            }
        }
        return fixedPosterUrl;
    };
    var getConfig = function(poster) {
        var config = props.config, ariaLabel = props.ariaLabel;
        var newConfig = _object_spread({}, config);
        newConfig.file = config.file || {};
        newConfig.file.attributes = _object_spread_props(_object_spread({}, newConfig.file.attributes), {
            poster: poster,
            "aria-label": ariaLabel
        });
        return newConfig;
    };
    /* Events */ var onClick = function() {
        props.onClick && props.onClick();
    };
    var onMouseEnter = function() {
        setHovered(true);
    };
    var onMouseLeave = function() {
        setHovered(false);
    };
    var onFocus = function() {
        if (!hovered) {
            setHadFocusWithKeyboardEvent(true);
        }
    };
    var onVisibilityChange = function(isVisible) {
        setTimeout(function() {
            return setVisible(isVisible);
        }, 200);
    };
    var showControls = function() {
        if (hideControls === undefined) {
            return !loop;
        }
        if (hideControls) {
            return false;
        }
        return hovered || hadFocusWithKeyboardEvent;
    };
    var style = props.style, playWhenVisible = props.playWhenVisible, loop = props.loop, muted = props.muted, volume = props.volume, playsInline = props.playsInline, hideControls = props.hideControls;
    var singleUrl = props.singleUrl, formats = props.formats, assetQuality = props.assetQuality, poster = props.poster, config = props.config, ariaLabel = props.ariaLabel, className = props.className, videoPlayerRef = props.videoPlayerRef, onStart = props.onStart, onEnded = props.onEnded, onDuration = props.onDuration, hideBlackBars = props.hideBlackBars;
    var memoizedUrl = (0,react.useMemo)(function() {
        return getUrl();
    }, [
        singleUrl,
        formats,
        assetQuality
    ]);
    var memoizedPoster = (0,react.useMemo)(function() {
        return getPoster();
    }, [
        poster,
        formats
    ]);
    var memoizedConfig = (0,react.useMemo)(function() {
        return getConfig(memoizedPoster);
    }, [
        memoizedPoster,
        config,
        ariaLabel
    ]);
    var tabIndex = hideControls ? -1 : 0;
    var getStyle = function() {
        var height = props.height;
        return height ? {
            height: height
        } : {};
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
        offset: {
            bottom: 100,
            top: 100
        },
        partialVisibility: true,
        onChange: onVisibilityChange,
        active: playWhenVisible,
        scrollCheck: playWhenVisible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledVideoComponent, {
            className: classnames_default()("video-component", {
                "hide-black-bars": hideBlackBars
            }),
            style: getStyle(),
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onFocus: onFocus,
            tabIndex: tabIndex,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactPlayer/* default */.ZP, {
                ref: videoPlayerRef,
                className: classnames_default()("react-player-video-component", className),
                url: [
                    memoizedUrl
                ],
                style: style,
                playsinline: playsInline,
                playing: shouldPlayVideo(),
                config: memoizedConfig,
                muted: muted,
                volume: volume,
                loop: loop,
                controls: showControls(),
                width: "100%",
                height: "100%",
                onStart: onStart,
                onEnded: onEnded,
                onDuration: onDuration
            })
        })
    });
};
VideoComponent.defaultProps = {
    formats: [],
    autoPlay: true,
    playWhenVisible: true,
    muted: true,
    volume: 0,
    config: {},
    playsInline: true,
    ariaLabel: null,
    singleUrl: null,
    videoPlayerRef: null
};
/* harmony default export */ var video_component = (VideoComponent);


/***/ }),

/***/ 26718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ window_mask; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var constants = __webpack_require__(73759);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/window-mask/window-mask.scss.js




var StyledWindowMask = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e8c38dm0"
})("display:flex;flex-direction:column;padding:", constants.COMPONENTS_SHADOW_PROPS.blurRadius + constants.COMPONENTS_SHADOW_PROPS.offsetY, "px\n    ", constants.COMPONENTS_SHADOW_PROPS.blurRadius + constants.COMPONENTS_SHADOW_PROPS.offsetX, "px;", constants.COMPONENTS_SHADOW_FILTER, "  .window-header{display:flex;height:15px;border-top-left-radius:8px;border-top-right-radius:8px;background:rgba(255,255,255,0.4);.circle-wrapper{display:flex;align-items:center;margin-left:8px;.circle{background:", colors/* default.white */.Z.white, ";height:5px;width:5px;border-radius:50%;margin-right:4px;}}}.content-wrapper{display:flex;flex-grow:1;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){padding:28px 8px;", constants.MOBILE_COMPONENTS_SHADOW_FILTER, "    .window-header{height:10px;border-top-left-radius:4px;border-top-right-radius:4px;.circle-wrapper{margin-left:4px;.circle{width:2.5px;height:2.5px;margin-right:3px;}}}img,video{border-bottom-left-radius:4px;border-bottom-right-radius:4px;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/window-mask/default-props.js
/* harmony default export */ var default_props = ({});

;// CONCATENATED MODULE: ./segments/desktop/core-components/window-mask/window-mask.js



var WindowMask = function(props) {
    var children = props.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWindowMask, {
        className: "window-mask",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "window-header",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "circle-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "circle"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "circle"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "circle"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "content-wrapper",
                children: children
            })
        ]
    });
};
/* harmony default export */ var window_mask = (WindowMask);
WindowMask.defaultProps = default_props;


/***/ })

}]);